import {fetchGet, generateEndpoint} from "../../../utils/request";

type GetCasesByUserLineIdParams = {
  token: string;
}

export const getCasesByUserLineId = async({ token }: GetCasesByUserLineIdParams) => {
  const url = `${generateEndpoint('getCasesByUserLineId')}`
  return fetchGet(url, token)
}
